(function () {
  'use strict';

  /* 連続操作で古い応答が DOM/URL を上書きしないための世代管理。セクション差し替えで initAll が
     再実行されても引き継げるようモジュールスコープに置く */
  var navState = { seq: 0, controller: null, fixHops: 0 };

  /* 1 操作あたりの「選び直し」の上限。これを超えたら投げ直さず、その応答を描画して止める */
  var MAX_FIX_HOPS = 3;

  /* 固定値パスワードは平文をコードに書かず SHA-256 で保持する */
  var GATE_PASSWORD_SHA256 = '6b5ea5b628c0c7519314aad9926ce9641507380337c39033f6b5b2de30fa24c4';

  /* 分割商品は木部ごとに別 product で、木部を選ぶと LinkedOption が別 product の素の URL へ
     遷移させる。選択は URL の ?option_values= にしか無いので遷移で失われる。Option 値の ID は
     product ごとに違うため、ID ではなく「Option 名 → 値の文字列」で控えて選び直す */
  var CARRY_KEY = 'mrn:linked-option-carry';
  /* 木部を選んでから遷移先の描画が終わるまでを覆い、それ以外のページ遷移へ持ち込まれない長さ */
  var CARRY_TTL_MS = 30000;

  function optionNames(form) {
    try {
      var names = JSON.parse(form.dataset.mrnOptionNames || '[]');
      return Array.isArray(names) ? names : [];
    } catch (e) {
      return [];
    }
  }

  function selectedValueText(axis) {
    var swatch = document.querySelector('[data-mrn-swatch][data-option-index="' + axis + '"].is-selected');
    if (swatch) return swatch.dataset.value || '';
    var sel = document.querySelector('[data-mrn-option][data-option-index="' + axis + '"]');
    var opt = sel && sel.options[sel.selectedIndex];
    return opt ? opt.textContent.trim() : '';
  }

  function saveCarry(e) {
    var form = document.querySelector('[data-mrn-variant-form]');
    if (!form) return;
    var handle = e && e.detail && e.detail.handle ? String(e.detail.handle) : '';
    var selection = {};
    var count = 0;
    optionNames(form).forEach(function (name, axis) {
      var value = selectedValueText(axis);
      if (!name || !value) return;
      selection[name] = value;
      count++;
    });
    try {
      if (count) {
        sessionStorage.setItem(CARRY_KEY, JSON.stringify({ at: Date.now(), to: handle, selection: selection }));
      } else {
        sessionStorage.removeItem(CARRY_KEY);
      }
    } catch (e) { /* 保存できない環境では引き継がないだけ（先頭の値のまま） */ }
  }

  /* 使えても使えなくても 1 回で消し、遷移先の handle があるときはそのページに着地したときだけ
     使う。遷移しなかった控えが、そのあとの普通のページ遷移に持ち込まれないため。遷移元と同じ
     商品かどうかは見ない（選択中の木部を選び直したときも同じ product の素の URL へ遷移する） */
  function takeCarry() {
    var memo = null;
    try {
      memo = JSON.parse(sessionStorage.getItem(CARRY_KEY) || 'null');
      sessionStorage.removeItem(CARRY_KEY);
    } catch (e) {
      return null;
    }
    if (!memo || typeof memo.selection !== 'object' || !memo.selection) return null;
    var age = Date.now() - Number(memo.at);
    if (!(age >= 0 && age <= CARRY_TTL_MS)) return null;
    if (memo.to && !isProductPage(String(memo.to))) return null;
    return memo.selection;
  }

  /* ロケール付き（/ja/products/…）も許容するため、末尾一致で見る */
  function isProductPage(handle) {
    var path = window.location.pathname.replace(/\/+$/, '');
    var tail = '/products/' + handle;
    return path.slice(-tail.length) === tail;
  }

  /* 値の文字列は記号を含むので、セレクタに埋めずに dataset を比べる。
     data-available / disabled は見ない。遷移先の availability は遷移先の初期選択を前提にした
     判定で、控えた値のもとでしか選べない値を捨てる。妥当性は navigate の unresolved 処理に任せる */
  function findValueByText(axis, value) {
    var swatches = document.querySelectorAll('[data-mrn-swatch][data-option-index="' + axis + '"]');
    for (var i = 0; i < swatches.length; i++) {
      if (swatches[i].dataset.value === value) return { id: swatches[i].dataset.valueId, swatch: swatches[i] };
    }
    var sel = document.querySelector('[data-mrn-option][data-option-index="' + axis + '"]');
    if (!sel) return null;
    for (var k = 0; k < sel.options.length; k++) {
      if (sel.options[k].textContent.trim() === value) return { id: sel.options[k].value, select: sel };
    }
    return null;
  }

  function initGallery(root) {
    var images = root.querySelectorAll('[data-mrn-gallery-image]');
    var thumbs = root.querySelectorAll('[data-mrn-gallery-thumb]');
    var caption = root.querySelector('[data-mrn-gallery-caption]');
    var counter = root.querySelector('[data-mrn-gallery-counter]');
    var stage = root.querySelector('[data-mrn-gallery-stage]');
    if (!images.length) {
      if (counter) counter.textContent = '';
      return;
    }

    var active = 0;

    function select(index) {
      active = (index + images.length) % images.length;
      images.forEach(function (img) {
        img.classList.toggle('is-active', Number(img.dataset.index) === active);
      });
      thumbs.forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.dataset.index) === active);
      });
      var current = root.querySelector('[data-mrn-gallery-thumb][data-index="' + active + '"]');
      if (caption && current) caption.textContent = current.dataset.caption || '';
      if (counter) counter.textContent = (active + 1) + ' / ' + images.length;
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { select(Number(btn.dataset.index)); });
      btn.addEventListener('mouseenter', function () {
        if (window.matchMedia('(min-width: 990px)').matches) select(Number(btn.dataset.index));
      });
    });

    if (stage) {
      var touchX = null;
      stage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchX == null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (dx < -40) select(active + 1);
        else if (dx > 40) select(active - 1);
      }, { passive: true });
    }

    select(0);
  }

  /* 先に選んだ軸の選択を優先し、選べなくなった後続軸だけを動かす。
     描画前の応答にも当てられるよう document ではなく root を受け取る */
  function findCorrection(root, axisCount) {
    for (var axis = 0; axis < axisCount; axis++) {
      var selectedSwatch = root.querySelector('[data-mrn-swatch][data-option-index="' + axis + '"].is-selected');
      if (selectedSwatch) {
        if (selectedSwatch.dataset.available !== 'false') continue;
        var alt = root.querySelector('[data-mrn-swatch][data-option-index="' + axis + '"][data-available="true"]');
        return alt ? { axis: axis, valueId: alt.dataset.valueId } : null;
      }
      var sel = root.querySelector('[data-mrn-option][data-option-index="' + axis + '"]');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        if (opt && !opt.disabled) continue;
        for (var k = 0; k < sel.options.length; k++) {
          if (!sel.options[k].disabled) return { axis: axis, valueId: sel.options[k].value };
        }
        return null;
      }
    }
    return null;
  }

  /* 行を選ぶとドロップダウンは即座に閉じるのに、応答が来るまでトリガーが元の値のままだと
     「選択が一度元に戻った」ように見えるため、クリックした値を先にトリガーへ反映する。
     最終的な整合性はサーバー描画で回復する */
  function applyPendingSelection(btn) {
    var axis = btn.dataset.optionIndex;
    if (axis == null) return;

    /* 値が無いときも必ず書き戻す。条件付きにすると、B を選んでから応答前に A へ戻したときに
       （A にメタや画像が無いと）B の値が残り、戻した側は再描画しないためサーバー描画で直らない */
    var nameEl = document.querySelector('[data-mrn-option-current="' + axis + '"]');
    if (nameEl) {
      /* 書き戻すのは表示文字列ではなく Option 値。サーバー描画の data-value と違う種類の値を
         入れると、再描画を挟んだ側と挟まない側で属性の意味が変わる */
      nameEl.textContent = btn.dataset.mrnTriggerName || btn.dataset.value || '';
      nameEl.dataset.value = btn.dataset.value || '';
      var metaEl = nameEl.parentNode && nameEl.parentNode.querySelector('.mrn-option__meta');
      if (metaEl) metaEl.textContent = btn.dataset.mrnTriggerMeta || '';
    }

    var chip = document.querySelector('[data-mrn-opener-chip="' + axis + '"]');
    if (chip) {
      /* 辞書の後追い（hydrateSwatchImages）が応答前に届いたとき、前の選択の画像を敷かないよう値も動かす */
      if (chip.hasAttribute('data-mrn-swatch-value')) chip.setAttribute('data-mrn-swatch-value', btn.dataset.value || '');
      /* 画像を持たない値へ変えたときに前の画像が残らないよう、無いときも必ず消す */
      var oldImg = chip.querySelector('.mrn-swatch__img');
      if (oldImg) oldImg.remove();
      var srcImg = btn.querySelector('.mrn-swatch__img');
      if (srcImg) {
        var img = srcImg.cloneNode(false);
        img.removeAttribute('loading'); /* トリガーは常に見えているので遅延させない */
        chip.appendChild(img);
      }
    }

    /* 再度開いたときに直前の選択が分かるよう、行側の状態も動かす */
    document.querySelectorAll('[data-mrn-swatch][data-option-index="' + axis + '"]').forEach(function (row) {
      var on = row === btn;
      row.classList.toggle('is-selected', on);
      if (row.hasAttribute('aria-selected')) row.setAttribute('aria-selected', on ? 'true' : 'false');
      var mark = row.querySelector('.mrn-listbox__mark, .mrn-swatch__mark');
      if (mark) mark.hidden = !on;
    });
  }

  /* 更新中であることを支援技術に伝えるだけで見た目は変えない。選んだ値はクリック直後に
     トリガーへ先行反映するので、画面全体を沈ませる必要はない */
  function setBusy(on) {
    var root = document.querySelector('[data-mrn-section-id]');
    if (!root) return;
    if (on) root.setAttribute('aria-busy', 'true');
    else root.removeAttribute('aria-busy');
  }

  /* 差し替えをまたいで保つ表示状態。どちらもブラウザ側だけが持つ状態で、サーバー描画には載らない */
  function captureViewState(root) {
    var tab = root.querySelector('[data-mrn-tab].is-active');
    var img = root.querySelector('[data-mrn-gallery-image].is-active');
    /* 選んだ直後にもう一度開くと、応答が来た時点の差し替えで開いた状態が消える。
       資料DLゲートは開いた時に JS が資料名と URL を入れるため、復元対象から外す。 */
    var openedModal = root.querySelector('.mrn-modal.is-open:not([data-mrn-gate])');
    var active = document.activeElement;
    var inside = !!(active && root.contains(active));
    return {
      tab: tab ? tab.dataset.mrnTab : null,
      image: img ? img.dataset.index : null,
      listboxOpen: !!root.querySelector('[data-mrn-listbox].is-open'),
      /* option にフォーカスがある＝キーボードで開いた場合だけ option へ戻す。
         トリガーも .mrn-listbox の内側にあるので、listbox 全体で見るとマウス操作でも
         true になってしまう（Chrome はクリックでボタンにフォーカスが乗る）。 */
      listboxFocused: !!(inside && active.closest('[role="option"]')),
      modalAxis: openedModal ? openedModal.dataset.mrnOptionModal : null,
      focus: inside ? focusKey(active) : null
    };
  }

  /* 差し替え後に同じ操作子へフォーカスを戻すための手掛かり。
     キーボードで値を選ぶと setListboxOpen がトリガーへフォーカスを戻すが、その直後に
     セクションごと差し替わるため、何もしないと body へ落ちて操作位置を見失う。 */
  function focusKey(el) {
    if (!el || !el.closest) return null;
    if (el.closest('[data-mrn-listbox-toggle]')) return '[data-mrn-listbox-toggle]';
    var opener = el.closest('[data-mrn-option-open]');
    if (opener) return '[data-mrn-option-open="' + opener.dataset.mrnOptionOpen + '"]';
    var sel = el.closest('[data-mrn-option][data-option-index]');
    if (sel) return '[data-mrn-option][data-option-index="' + sel.dataset.optionIndex + '"]';
    return null;
  }

  function restoreViewState(state) {
    if (!state) return;
    /* 既存のハンドラを通して戻す（aria-selected・キャプション・カウンタも一緒に揃う） */
    if (state.tab) {
      var tab = document.querySelector('[data-mrn-tab="' + state.tab + '"]');
      if (tab && !tab.classList.contains('is-active')) tab.click();
    }
    if (state.image) {
      var thumb = document.querySelector('[data-mrn-gallery-thumb][data-index="' + state.image + '"]');
      if (thumb && !thumb.classList.contains('is-active')) thumb.click();
    }
    var focusedOption = false;
    if (state.listboxOpen) {
      var lb = document.querySelector('[data-mrn-listbox]');
      /* フォーカスが中にあったときだけ option へ戻す（マウス操作で焦点を奪わない） */
      if (lb) { setListboxOpen(lb, true, state.listboxFocused); focusedOption = state.listboxFocused; }
    }
    if (state.modalAxis != null) {
      var modal = document.querySelector('.mrn-modal[data-mrn-option-modal="' + state.modalAxis + '"]');
      if (modal) openModal(modal);
    }
    /* option へ戻した場合はそちらが優先。:focus-visible なのでマウス操作では枠は出ない */
    if (!focusedOption && state.focus) {
      var el = document.querySelector(state.focus);
      if (el) el.focus();
    }
  }

  /* role="tab" を名乗る以上、選択状態（aria-selected）と矢印キー移動まで揃える
     （WAI-ARIA の tabs パターン。aria-selected の無い role="tab" は読み上げ側で状態が取れない）。 */
  function initTabs(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-mrn-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mrn-panel]'));

    function select(btn, moveFocus) {
      buttons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        /* roving tabindex: Tab キーでは選択中のタブだけに止まり、左右キーで移動する */
        b.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.mrnPanel === btn.dataset.mrnTab);
      });
      if (moveFocus) btn.focus();
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(btn); });
      btn.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (step) {
          e.preventDefault();
          select(buttons[(i + step + buttons.length) % buttons.length], true);
        } else if (e.key === 'Home') {
          e.preventDefault();
          select(buttons[0], true);
        } else if (e.key === 'End') {
          e.preventDefault();
          select(buttons[buttons.length - 1], true);
        }
      });
    });
  }

  /* variant の解決も値ごとの価格・Metafield 表示もサーバーに任せる（250 件超の商品でも成立する）。
     view / preview_theme_id 等の既存クエリを落とさないよう、URL 全体を保持したまま差し替える */
  function initVariantForm(form) {
    var initialIds = (form.dataset.mrnCurrentIds || '').split(',');
    var currentIds = initialIds.slice();

    /* 連続操作で古い応答が後から反映されないよう、リクエストに世代番号を振って進行中の fetch は
       Abort する。取得できないときはフルリロードにフォールバックする */
    function navigate() {
      if (currentIds.join(',') === initialIds.join(',')) {
        /* 表示は既にこの状態なので取得は要らない。ただし進行中の取得は必ず無効化する。
           そのまま return すると、直前に投げた別の値の応答が最新世代のまま残り、
           最後に選んだ値ではなくそちらが DOM と URL に反映される */
        navState.seq++;
        if (navState.controller) { navState.controller.abort(); navState.controller = null; }
        /* 選び直し（unresolved の補正）で初期状態まで戻ったときは、ここで止めない。
           引き継ぎで先行反映したトリガー・行の表示が残り、variant・価格は初期のままで
           食い違う。初期状態を取得し直して描画し、表示を揃える。 */
        if (navState.fixHops === 0) {
          setBusy(false);
          /* 世代を進めると initPendingSwatches の取得結果も捨てられる。ここは再描画しないので
             やり直さないと、価格が空欄の pending スウォッチが次の操作まで残る。 */
          initPendingSwatches();
          initUnresolvedFabricGroups();
          return;
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('option_values', currentIds.join(','));

      var root = document.querySelector('[data-mrn-section-id]');
      var sectionId = root && root.dataset.mrnSectionId;
      if (!sectionId || !window.fetch || !window.DOMParser) {
        window.location.assign(url.toString());
        return;
      }
      setBusy(true);
      var seq = ++navState.seq;
      if (navState.controller) navState.controller.abort();
      var controller = window.AbortController ? new AbortController() : null;
      navState.controller = controller;

      var fetchUrl = new URL(url.toString());
      fetchUrl.searchParams.set('section_id', sectionId);
      fetch(fetchUrl.toString(), controller ? { signal: controller.signal } : {})
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          if (seq !== navState.seq) return; /* より新しい選択が走っている */
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-mrn-section-id]');
          if (!next) throw new Error('section not found');
          /* 組み合わせが無い描画は見せない。選び直す値だけ取り出して 2 回目を投げる。描画してから
             直すと誤った状態が一瞬見える。product_option_value.variant は全軸の現在選択でしか
             解決せず product.variants も 250 件で頭打ちなので、往復を 1 回にはできない */
          if (next.hasAttribute('data-mrn-unresolved')) {
            var fix = findCorrection(next, currentIds.length);
            /* 描画せずに投げ直すため、繰り返しても画面には出ない。想定は 1 回で収まることだが、
               収まらないデータに当たったときに黙って通信し続けないよう上限を設ける。
               超えたらその応答をそのまま描画して、状態が見える形で止める。 */
            if (fix && currentIds[fix.axis] !== fix.valueId && navState.fixHops < MAX_FIX_HOPS) {
              navState.fixHops++;
              currentIds[fix.axis] = fix.valueId;
              navigate(); /* busy は解除せず 2 回目へ */
              return;
            }
          }
          /* replaceWith 後に別応答が来るケースに備え、その時点の root を引き直す */
          var liveRoot = document.querySelector('[data-mrn-section-id]');
          if (!liveRoot) throw new Error('section missing');
          /* セクションを丸ごと差し替えるとサーバー描画の初期状態（先頭タブ・1枚目の画像）に戻るため、
             開いているタブと表示中の画像を控えて戻す */
          var viewState = captureViewState(liveRoot);
          liveRoot.replaceWith(next);
          history.replaceState({}, '', url.toString());
          initAll();
          restoreViewState(viewState);
          setBusy(false);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; /* 新しい選択に置き換わった */
          if (seq !== navState.seq) return;
          window.location.assign(url.toString());
        });
    }

    /* 後続軸の選択は破棄せず維持する。維持した組み合わせが存在しない場合はサーバーの variant 解決が
       null になり、下の unresolved 処理が「選べなくなった軸」だけを別の値へ切り替える */
    function selectValue(axis, newId) {
      if (currentIds[axis] === newId) return;
      currentIds[axis] = newId;
      navState.fixHops = 0; /* ユーザー操作が起点なので選び直しの回数を数え直す */
      navigate();
    }

    form.addEventListener('change', function (e) {
      var s = e.target.closest('[data-mrn-option]');
      if (!s) return;
      selectValue(Number(s.dataset.optionIndex), s.value);
    });

    /* 変える軸をまとめて currentIds に入れ、取得は 1 回で済ませる。選び直した組み合わせが存在しない
       ときは、navigate の unresolved 処理が選べなくなった軸を選べる値へ切り替える */
    function applyCarry() {
      var selection = takeCarry();
      if (!selection) return false;
      var changed = false;
      optionNames(form).forEach(function (name, axis) {
        if (axis >= currentIds.length) return;
        if (!Object.prototype.hasOwnProperty.call(selection, name)) return;
        var found = findValueByText(axis, String(selection[name]));
        if (!found || !found.id || currentIds[axis] === found.id) return;
        currentIds[axis] = found.id;
        /* 応答が来るまで先頭の値が出たままにしない（クリック時と同じ先行反映） */
        if (found.swatch) applyPendingSelection(found.swatch);
        if (found.select) found.select.value = found.id;
        changed = true;
      });
      if (!changed) return false;
      navState.fixHops = 0;
      navigate();
      return true;
    }
    var carried = applyCarry();

    var rootEl = document.querySelector('[data-mrn-section-id]');
    if (!carried && rootEl && rootEl.hasAttribute('data-mrn-unresolved')) {
      var fix = findCorrection(rootEl, currentIds.length);
      if (fix) selectValue(fix.axis, fix.valueId);
    }

    document.querySelectorAll('[data-mrn-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* 前方軸の選択だけを考慮した availability（top-down）で false の値は選択させない */
        if (btn.dataset.available === 'false') return;
        var modal = btn.closest('.mrn-modal');
        if (modal) modal.classList.remove('is-open');
        var listbox = btn.closest('[data-mrn-listbox]');
        if (listbox) setListboxOpen(listbox, false);
        /* 選択済みの値を選び直したときは閉じるだけ。ここで先行反映すると、selectValue が
           早期 return して取得も再描画も走らないため、書き換えた表示がそのまま残る。 */
        var clickedAxis = Number(btn.dataset.optionIndex);
        if (currentIds[clickedAxis] !== btn.dataset.valueId) applyPendingSelection(btn);
        selectValue(clickedAxis, btn.dataset.valueId);
      });
    });

    /* スウォッチの価格は Liquid（product_option_value.variant）でサーバー描画するため
       JS での価格埋めは行わない（選択が変わるたびに Section Rendering で再計算される）。 */
  }

  function openModal(modal) { modal.classList.add('is-open'); }
  function closeModal(modal) { modal.classList.remove('is-open'); }

  /* どの軸に listbox を出すかは Liquid 側が Option 名で決めるため、JS は軸番号に依存しない。
     行の選択は initVariantForm の data-mrn-swatch ハンドラが担う */
  function listboxOptions(listbox) {
    return Array.prototype.slice.call(listbox.querySelectorAll('[role="option"]'));
  }

  /* open 時は option へフォーカスを移し、閉じたらトリガーへ戻す。
     roving tabindex: 閉じている間は Tab がトリガーだけに止まる（option 10 個を素通りしない）。 */
  function setListboxOpen(listbox, open, focusOption) {
    var wasInside = listbox.contains(document.activeElement);
    listbox.classList.toggle('is-open', open);
    var trigger = listbox.querySelector('[data-mrn-listbox-toggle]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    var options = listboxOptions(listbox);
    options.forEach(function (o) { o.tabIndex = -1; });
    if (open && focusOption) {
      var selected = options.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0];
      var target = selected || options[0];
      if (target) { target.tabIndex = 0; target.focus(); }
    } else if (!open && wasInside && trigger) {
      trigger.focus();
    }
  }

  function moveListboxFocus(listbox, from, step) {
    var options = listboxOptions(listbox);
    if (!options.length) return;
    var i = options.indexOf(from);
    var next = step === 'first' ? 0
      : step === 'last' ? options.length - 1
      : (i + step + options.length) % options.length;
    options.forEach(function (o) { o.tabIndex = -1; });
    options[next].tabIndex = 0;
    options[next].focus();
  }

  /* WAI-ARIA の listbox パターン（role="listbox" / role="option" を出している以上、
     キーボードでも選べるようにする）。LinkedOption のドロップダウンとも操作が揃う。 */
  function initListboxes() {
    document.querySelectorAll('[data-mrn-listbox]').forEach(function (listbox) {
      var trigger = listbox.querySelector('[data-mrn-listbox-toggle]');
      if (trigger) {
        trigger.addEventListener('click', function () {
          setListboxOpen(listbox, !listbox.classList.contains('is-open'));
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
            /* preventDefault で click の二重発火（Enter / Space）とページスクロールを止める */
            e.preventDefault();
            setListboxOpen(listbox, true, true);
          }
        });
      }
      listbox.querySelectorAll('[data-mrn-listbox-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { setListboxOpen(listbox, false); });
      });
      listbox.addEventListener('keydown', function (e) {
        if (!listbox.classList.contains('is-open')) return;
        var option = e.target.closest('[role="option"]');
        if (e.key === 'Escape') { setListboxOpen(listbox, false); return; }
        if (e.key === 'Tab') { setListboxOpen(listbox, false); return; }
        if (!option) return;
        /* Enter / Space は button の click がそのまま選択になるので触らない */
        if (e.key === 'ArrowDown') { e.preventDefault(); moveListboxFocus(listbox, option, 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); moveListboxFocus(listbox, option, -1); }
        else if (e.key === 'Home') { e.preventDefault(); moveListboxFocus(listbox, option, 'first'); }
        else if (e.key === 'End') { e.preventDefault(); moveListboxFocus(listbox, option, 'last'); }
      });
      /* 閉じた状態の初期 tabindex を揃える */
      if (!listbox.classList.contains('is-open')) {
        listboxOptions(listbox).forEach(function (o) { o.tabIndex = -1; });
      }
    });
  }

  function initModals() {
    document.querySelectorAll('[data-mrn-option-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.querySelector('[data-mrn-option-modal="' + btn.dataset.mrnOptionOpen + '"]');
        if (modal) openModal(modal);
      });
    });
    document.querySelectorAll('.mrn-modal').forEach(function (modal) {
      modal.querySelectorAll('[data-mrn-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeModal(modal); });
      });
    });
    /* document レベルのリスナーはセクション差し替え後の再初期化でも 1 つだけ */
    if (!initModals.bound) {
      initModals.bound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.mrn-modal.is-open').forEach(closeModal);
        document.querySelectorAll('[data-mrn-listbox].is-open').forEach(function (lb) { setListboxOpen(lb, false); });
      });
    }
  }

  /* セクション差し替えで要素が入れ替わるため、リスナーは 1 つでその都度 DOM を引く */
  function stickyOnScroll() {
    var bar = document.querySelector('[data-mrn-sticky]');
    var cta = document.querySelector('[data-mrn-cta]');
    if (!bar || !cta) return;
    bar.classList.toggle('is-visible', cta.getBoundingClientRect().bottom < 0);
  }
  function initStickyBar() {
    if (!initStickyBar.bound) {
      initStickyBar.bound = true;
      window.addEventListener('scroll', stickyOnScroll, { passive: true });
    }
    stickyOnScroll();
  }

  function sha256Hex(text) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return b.toString(16).padStart(2, '0');
      }).join('');
    });
  }

  function initGate() {
    var gate = document.querySelector('[data-mrn-gate]');
    if (!gate) return;
    var nameEl = gate.querySelector('[data-mrn-gate-name]');
    var idInput = gate.querySelector('[data-mrn-gate-id]');
    var input = gate.querySelector('[data-mrn-gate-input]');
    var submit = gate.querySelector('[data-mrn-gate-submit]');
    var toggle = gate.querySelector('[data-mrn-gate-toggle]');
    var targetUrl = '';

    if (toggle && input) {
      toggle.addEventListener('click', function () {
        var show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        toggle.textContent = show ? '隠す' : '表示';
        toggle.setAttribute('aria-label', show ? 'パスワードを隠す' : 'パスワードを表示');
      });
    }

    /* 表示（クラス）と支援技術（aria-invalid）は必ず対で動かす。
       aria-describedby はエラー時だけ結ぶ: 常時結ぶと参照先が display:none でも
       アクセシブルな説明として読まれ得るため、検証前のフォーカスでエラー文が通知される */
    function markFieldAria(field, on, errorId) {
      if (!field) return;
      field.setAttribute('aria-invalid', on ? 'true' : 'false');
      if (on && errorId) field.setAttribute('aria-describedby', errorId);
      else field.removeAttribute('aria-describedby');
    }

    function markError(field, cls, on) {
      gate.classList.toggle(cls, on);
      markFieldAria(field, on, field && field.dataset.mrnErrorId);
    }

    /* 「未入力」と「不一致」は排他表示なので、片方を立てるときは他方を必ず下げる */
    function markPwError(kind) {
      gate.classList.toggle('has-error-pw-empty', kind === 'empty');
      gate.classList.toggle('has-error', kind === 'mismatch');
      if (!input) return;
      markFieldAria(input, !!kind, kind === 'empty' ? input.dataset.mrnEmptyErrorId : input.dataset.mrnErrorId);
    }

    if (idInput) idInput.addEventListener('input', function () { markError(idInput, 'has-error-id', false); });
    if (input) input.addEventListener('input', function () { markPwError(''); });

    document.querySelectorAll('[data-mrn-gate-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        targetUrl = btn.dataset.docUrl;
        if (nameEl) nameEl.textContent = (btn.dataset.docName || '') + '（法人向け）';
        var descEl = gate.querySelector('[data-mrn-gate-desc]');
        if (descEl) descEl.textContent = btn.dataset.docDesc || '';
        markPwError('');
        markError(idInput, 'has-error-id', false);
        if (idInput) idInput.value = '';
        if (input) input.value = '';
        openModal(gate);
      });
    });

    if (submit) {
      submit.addEventListener('click', function () {
        /* ID は入力させるだけで照合せず、空欄のときだけエラーにする。判定は常にパスワードのみ */
        var idOk = !idInput || !!idInput.value.trim();
        markError(idInput, 'has-error-id', !idOk);
        /* 空欄は照合前に必須エラーにする。照合して「正しくありません」になると、入れ忘れなのか
           間違いなのかが伝わらない。空白だけの入力も空欄扱いにする */
        var pw = input ? input.value : '';
        if (!pw.trim()) {
          markPwError('empty');
          return;
        }
        sha256Hex(pw).then(function (hex) {
          var pwOk = hex === GATE_PASSWORD_SHA256 && !!targetUrl;
          markPwError(pwOk ? '' : 'mismatch');
          if (idOk && pwOk) {
            closeModal(gate);
            window.open(targetUrl, '_blank', 'noopener');
          }
        });
      });
    }
  }

  function resolveBase() {
    var rootEl = document.querySelector('[data-mrn-section-id]');
    /* unresolved 中は直後の選び直しで再描画されるので、その後の initAll で解決する */
    if (!rootEl || rootEl.hasAttribute('data-mrn-unresolved')) return null;
    /* 引き継ぎの選び直しが走っている間も同じ。いまの描画はすぐ差し替わる */
    if (rootEl.hasAttribute('aria-busy')) return null;
    var form = document.querySelector('[data-mrn-variant-form]');
    if (!form) return null;
    var sectionId = rootEl.dataset.mrnSectionId;
    if (!sectionId) return null;
    return { ids: (form.dataset.mrnCurrentIds || '').split(','), sectionId: sectionId, seq: navState.seq };
  }

  /* セレクト（data-mrn-option）だけを見ると、リストボックスで描く木部の値を取り落とす */
  function altValueIds(axis, currentId) {
    var out = [];
    var swatches = document.querySelectorAll('[data-mrn-swatch][data-option-index="' + axis + '"]');
    if (swatches.length) {
      Array.prototype.forEach.call(swatches, function (sw) {
        var id = sw.dataset.valueId;
        if (id && id !== currentId) out.push(id);
      });
      return out;
    }
    var sel = document.querySelector('[data-mrn-option][data-option-index="' + axis + '"]');
    if (!sel) return out;
    for (var k = 0; k < sel.options.length; k++) {
      if (sel.options[k].value && sel.options[k].value !== currentId) out.push(sel.options[k].value);
    }
    return out;
  }

  function fetchAltDocs(base, alts) {
    return Promise.all(alts.map(function (alt) {
      var url = new URL(window.location.href);
      var q = base.ids.slice();
      q[alt.axis] = alt.id;
      url.searchParams.set('option_values', q.join(','));
      url.searchParams.set('section_id', base.sectionId);
      return fetch(url.toString())
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { return html ? new DOMParser().parseFromString(html, 'text/html') : null; })
        .catch(function () { return null; });
    }));
  }

  /* available=true でも後続軸の現在値との組み合わせが無い値は Liquid で価格・Metafield を解決
     できない（product_option_value.variant は他の全軸の現在選択との完全一致しか返さない）ので、
     後続軸の各代替値で Section Rendering を取って補う。取得数は variant 件数に依存しない */
  function initPendingSwatches() {
    var pend = Array.prototype.slice.call(document.querySelectorAll('[data-mrn-swatch][data-mrn-pending]'));
    if (!pend.length) return;
    var base = resolveBase();
    if (!base) return;

    /* 生地は必ずしも 2 軸目ではない（木部を持たない商品では 1 軸目）ので、軸番号は DOM から読む */
    var pendingAxis = Number(pend[0].dataset.optionIndex);
    if (!isFinite(pendingAxis)) return;

    /* 生地より後ろの軸の「現在値以外」の値 ID を軸順・値順で列挙。
       この順 = 選べなくなったときに選び直す順なので、最初に解決できた描画の価格が
       「その値をクリックした後に確定する価格」と一致する。 */
    var alts = [];
    for (var axis = pendingAxis + 1; axis < base.ids.length; axis++) {
      altValueIds(axis, base.ids[axis]).forEach(function (id) { alts.push({ axis: axis, id: id }); });
    }
    if (!alts.length) return;

    fetchAltDocs(base, alts).then(function (docs) {
      if (base.seq !== navState.seq) return; /* 取得中に選択が変わった（新しい描画側で再解決される） */
      pend.forEach(function (btn) {
        if (!btn.isConnected) return;
        for (var i = 0; i < docs.length; i++) {
          if (!docs[i]) continue;
          var src = docs[i].querySelector('[data-mrn-swatch][data-value-id="' + btn.dataset.valueId + '"]');
          if (!src || src.hasAttribute('data-mrn-pending')) continue; /* この描画でも未解決 */
          applyResolvedSwatch(btn, src);
          break;
        }
      });
    });
  }

  /* 差し替えるのは前方軸 1 つだけ。複数軸の総当りにすると取得数が軸の値数の積になるので、
     1 つでは解決しない値（別軸との組み合わせでしか現れない値）は未解決のまま残す */
  function initUnresolvedFabricGroups() {
    var pend = Array.prototype.slice.call(document.querySelectorAll('[data-mrn-swatch][data-mrn-group-pending]'));
    if (!pend.length) return;
    var base = resolveBase();
    if (!base) return;

    var fabricAxis = Number(pend[0].dataset.optionIndex);
    if (!isFinite(fabricAxis)) return;

    var alts = [];
    for (var axis = 0; axis < fabricAxis; axis++) {
      altValueIds(axis, base.ids[axis]).forEach(function (id) { alts.push({ axis: axis, id: id }); });
    }
    if (!alts.length) return;

    fetchAltDocs(base, alts).then(function (docs) {
      if (base.seq !== navState.seq) return;
      pend.forEach(function (btn) {
        if (!btn.isConnected) return;
        for (var i = 0; i < docs.length; i++) {
          if (!docs[i]) continue;
          var src = docs[i].querySelector('[data-mrn-swatch][data-value-id="' + btn.dataset.valueId + '"]');
          /* data-mrn-pending の側もランク・布名は 250 件走査の best-effort なので当てにしない。
             誤ったグループへ移すより、見出しの無いままの方が直すべき場所が分かる */
          if (!src || src.hasAttribute('data-mrn-group-pending') || src.hasAttribute('data-mrn-pending')) continue;
          syncResolvedSwatchText(btn, src);
          moveToResolvedGroup(btn, src);
          btn.removeAttribute('data-mrn-group-pending');
          break;
        }
      });
    });
  }

  /* グループの同一性は data-mrn-group-key（fabric_rank + 半角スペース + fabric_series）で見る。
     見出しはランクと布名を別 span に割っているため、.mrn-swatch-group__title だけを読むと
     「M-01 MAYA」と「M-01 Hallingdal」がどちらも "M-01" になり、別シリーズへ紛れ込む */
  function swatchGroupKey(group) {
    if (!group) return '';
    var key = group.getAttribute && group.getAttribute('data-mrn-group-key');
    if (key) return key;
    var t = group.querySelector('.mrn-swatch-group__title');
    return t ? t.textContent.trim() : '';
  }

  function adjustGroupCount(group, delta) {
    var el = group && group.querySelector('.mrn-swatch-group__count');
    if (!el) return;
    var n = parseInt(el.textContent, 10);
    if (!isNaN(n)) el.textContent = (n + delta) + ' 色';
  }

  function applyResolvedSwatch(btn, src) {
    var priceEl = btn.querySelector('[data-mrn-price-pending]');
    var srcPrice = src.querySelector('.mrn-swatch__price');
    if (priceEl && srcPrice) {
      priceEl.textContent = srcPrice.textContent;
      priceEl.removeAttribute('data-mrn-price-pending');
    }
    syncResolvedSwatchText(btn, src);
    moveToResolvedGroup(btn, src);
    btn.removeAttribute('data-mrn-pending');
  }

  /* ランクは Option 値を JS でパースして削らない（記号込みで一意性を担保していて割り戻しが壊れる）。
     価格だけは写さない。選択不可の値に確定した価格は無い */
  function syncResolvedSwatchText(btn, src) {
    var nameEl = btn.querySelector('.mrn-swatch__name');
    var srcName = src.querySelector('.mrn-swatch__name');
    if (nameEl && srcName) nameEl.textContent = srcName.textContent;
    var srcCode = src.querySelector('.mrn-swatch__code');
    var row = btn.querySelector('.mrn-swatch__row');
    if (srcCode && row && !btn.querySelector('.mrn-swatch__code')) {
      row.parentNode.insertBefore(srcCode.cloneNode(true), row.nextSibling);
    }
  }

  function moveToResolvedGroup(btn, src) {
    var srcGroup = src.closest('.mrn-swatch-group');
    var curGroup = btn.closest('.mrn-swatch-group');
    if (!srcGroup || !curGroup) return;
    var want = swatchGroupKey(srcGroup);
    if (want === swatchGroupKey(curGroup)) return;

    /* Liquid のフォールバックと違うグループに解決された場合は移動する */
    var container = curGroup.parentNode;
    var target = null;
    Array.prototype.forEach.call(container.children, function (g) {
      if (!target && g !== curGroup && swatchGroupKey(g) === want) target = g;
    });
    if (!target) {
      /* 現 DOM に無いグループは、取得した描画の見出しごと複製して同じ並び位置に挿入 */
      target = document.createElement('div');
      target.className = srcGroup.className;
      var srcKey = srcGroup.getAttribute('data-mrn-group-key');
      if (srcKey) target.setAttribute('data-mrn-group-key', srcKey);
      var head = srcGroup.querySelector('.mrn-swatch-group__head');
      if (head) {
        head = head.cloneNode(true);
        var cnt = head.querySelector('.mrn-swatch-group__count');
        if (cnt) cnt.textContent = '0 色'; /* 下の一律 +1 で数える */
        target.appendChild(head);
      }
      var list = document.createElement('div');
      list.className = 'mrn-swatches';
      target.appendChild(list);
      var anchor = null;
      var after = false;
      Array.prototype.forEach.call(srcGroup.parentNode.children, function (g) {
        if (g === srcGroup) { after = true; return; }
        if (!after || anchor) return;
        var title = swatchGroupKey(g);
        Array.prototype.forEach.call(container.children, function (c) {
          if (!anchor && swatchGroupKey(c) === title) anchor = c;
        });
      });
      container.insertBefore(target, anchor);
    }
    target.querySelector('.mrn-swatches').appendChild(btn);
    adjustGroupCount(target, 1);
    adjustGroupCount(curGroup, -1);
    if (!curGroup.querySelector('[data-mrn-swatch]')) curGroup.remove();
  }

  /* 埋め込み先は幅 360px 未満で崩れる（ツールチップの重なり・折り返し）ので、枠が足りないときは
     iframe を 360px で描画して transform で縮める。CSS だけでは「枠の幅 ÷ 360」を無単位の数に
     できない（長さ同士の割り算は古い iOS が未対応）。足りていればインラインスタイルを外す */
  var CONFIGURATOR_MIN_WIDTH = 360;
  function fitConfigurator() {
    document.querySelectorAll('.mrn-configurator__frame').forEach(function (frame) {
      var iframe = frame.querySelector('.mrn-configurator__iframe');
      if (!iframe) return;
      var w = frame.clientWidth;
      if (!w || w >= CONFIGURATOR_MIN_WIDTH) {
        iframe.style.width = iframe.style.height = iframe.style.transform = iframe.style.transformOrigin = '';
        return;
      }
      var scale = w / CONFIGURATOR_MIN_WIDTH;
      iframe.style.width = CONFIGURATOR_MIN_WIDTH + 'px';
      iframe.style.height = Math.round(frame.clientHeight / scale) + 'px';
      iframe.style.transformOrigin = '0 0';
      iframe.style.transform = 'scale(' + scale + ')';
    });
  }
  function initConfigurator() {
    if (!document.querySelector('.mrn-configurator__frame')) return;
    if (!initConfigurator.bound) {
      initConfigurator.bound = true;
      window.addEventListener('resize', fitConfigurator);
    }
    fitConfigurator();
  }

  function filmEmbedUrl(href) {
    var url;
    try { url = new URL(href); } catch (e) { return null; }
    var host = url.hostname.replace(/^www\./, '');
    var m;
    if (host === 'vimeo.com' || host === 'player.vimeo.com') {
      /* 動画ページの形だけを受ける（/showcase/<id> や /event/<id> など、動画以外を指す数字は拾わない）。
         限定公開の動画は vimeo.com/<id>/<hash> か ?h=<hash> でハッシュが付く。無いと再生できない */
      m = url.pathname.match(/^\/(?:video\/|channels\/[^/]+\/|groups\/[^/]+\/videos\/|(?:showcase|album)\/\d+\/video\/)?(\d+)(?:\/([0-9a-f]+))?\/?$/);
      if (!m) return null;
      var hash = m[2] || url.searchParams.get('h');
      return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' + (hash ? '&h=' + encodeURIComponent(hash) : '');
    }
    var id = null;
    if (host === 'youtu.be') {
      id = url.pathname.split('/')[1];
    } else if (host === 'youtube.com' || host === 'm.youtube.com') {
      if (url.pathname === '/watch') id = url.searchParams.get('v');
      else if ((m = url.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)/))) id = m[1];
    }
    /* playsinline: iOS で全画面に切り替わらず、カード内で再生する */
    return id && /^[\w-]+$/.test(id) ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1' : null;
  }

  function initFilms() {
    document.querySelectorAll('[data-mrn-film]').forEach(function (link) {
      var src = filmEmbedUrl(link.href);
      var stage = link.querySelector('.mrn-film__stage');
      if (!src || !stage) return;
      link.addEventListener('click', function (e) {
        /* 修飾キー付きのクリック（別タブ・別ウィンドウで開く操作）はリンクの動作に任せる */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        /* 差し替え済み（同じリンクに初期化が重なった場合の 2 回目）は何もしない */
        if (!link.isConnected) return;
        var title = link.querySelector('.mrn-film__title');
        var frame = document.createElement('iframe');
        frame.className = 'mrn-film__player';
        frame.src = src;
        frame.title = title ? title.textContent.trim() : '';
        frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
        frame.setAttribute('allowfullscreen', '');
        stage.replaceChildren(frame);
        /* プレーヤーをリンクの中に残さない（a の中に操作できる要素は置けない）。タイトル・説明文はそのまま残す */
        link.replaceWith.apply(link, Array.prototype.slice.call(link.childNodes));
        frame.focus();
      });
    });
  }

  /* Liquid の対応表では描けないチップが残るため、辞書で埋める。取得はページ内で 1 回で、
     セクション差し替え後はキャッシュから再適用される */
  function hydrateSwatchImages() {
    var dict = window.MaruniSwatchDictionary;
    if (dict && dict.apply) dict.apply(document);
  }

  /* セクション差し替え（Section Rendering）後にも再実行するため関数化 */
  function initAll() {
    document.querySelectorAll('[data-mrn-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-mrn-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-mrn-variant-form]').forEach(initVariantForm);
    initPendingSwatches();
    initUnresolvedFabricGroups();
    initListboxes();
    initModals();
    initStickyBar();
    initGate();
    initConfigurator();
    initFilms();
    hydrateSwatchImages();
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('mrn:linked-option:before-switch', saveCarry);
})();
